'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    'div',
    { className: 'container-fluid margin-top-20 text-center' },
    _react2.default.createElement(
      'h1',
      null,
      'Doh! 404!'
    ),
    _react2.default.createElement(
      'p',
      null,
      'These are ',
      _react2.default.createElement(
        'em',
        null,
        'not'
      ),
      ' the droids you are looking for!'
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _Link2.default,
        { className: 'btn btn-primary', to: '/' },
        'Home Page'
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 2177
// module chunks = 1